import { IEvaluationTypeService } from "../../service/evaluation/EvaluationTypeService";

export default class JoinRuleGroupToEvaluationTypeInteractor {
  private evaluationTypeService: IEvaluationTypeService;

  constructor(evaluationTypeService) {
    this.evaluationTypeService = evaluationTypeService;
  }

  async execute(evaluationTypeId: number, ruleGroupId: number) {
    return this.evaluationTypeService.joinRuleGroupToEvaluationType(
      evaluationTypeId,
      ruleGroupId
    );
  }
}
